(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('pb-anim');

  var headings = document.querySelectorAll('h2.title, .title-wrapper .title');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('pb-in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.3 });

  headings.forEach(function (el) { io.observe(el); });
})();